import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectSession } from '@client/model/selectors';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LogOut, Home as HomeIcon } from 'lucide-react';
import { useClientSignOut } from '@client/components/hooks/use-sign-out';

export function AdvisorClientAccessConflictPage() {
  const { advisor } = useSelector(selectSession);
  const handleClientSignOut = useClientSignOut();

  const handleSignOutAndContinue = () => {
    // The useClientSignOut hook already preserves the client_sign_in=true parameter
    // and login_hint through the sign-out flow
    handleClientSignOut();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <Card className="border shadow-lg">
          <CardContent className="p-8">
            <div className="mb-6 text-center">
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
                <LogOut className="h-6 w-6 text-amber-600" />
              </div>
              <h1 className="mb-2 text-2xl font-semibold text-gray-900">Log Out Required</h1>
              <p className="text-gray-600">
                You need to log out of your advisor account to access this client link.
              </p>
            </div>

            <div className="mb-6 space-y-4">
              <div className="rounded-lg bg-blue-50 p-4">
                <p className="text-sm text-blue-800">
                  <strong>What's happening?</strong> You clicked a client access link while logged
                  in as an advisor. Client access links are for clients to view their own results.
                </p>
              </div>

              {advisor && (
                <div className="text-sm text-gray-600">
                  <p>
                    <strong>Current user:</strong> {advisor.advisorFirstName}{' '}
                    {advisor.advisorLastName}
                  </p>
                </div>
              )}
            </div>

            <div className="space-y-3">
              <Button
                onClick={handleSignOutAndContinue}
                className="w-full"
                size="lg"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Sign Out & Continue as Client
              </Button>

              <Button
                asChild
                variant="outline"
                className="w-full"
                size="lg"
              >
                <Link to="/">
                  <HomeIcon className="mr-2 h-4 w-4" />
                  Return to Advisor Dashboard
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
